var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightQuote = function SvgRightQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.56.18c.23 0 .346.112.346.338v9.818c0 2.031-.49 3.837-1.471 5.417-.98 1.636-2.25 2.905-3.807 3.808C4.012 20.521 2.282 21 .436 21v-5.247c1.442 0 2.682-.537 3.72-1.608.981-1.073 1.472-2.342 1.472-3.81H.782c-.23 0-.346-.112-.346-.338V.518C.436.292.55.179.782.179h9.778Zm16.094 0c.23 0 .346.112.346.338v9.818c0 2.031-.49 3.837-1.471 5.417-.98 1.636-2.25 2.905-3.807 3.808-1.615.96-3.346 1.439-5.192 1.439v-5.247c1.442 0 2.682-.537 3.72-1.608.982-1.073 1.472-2.342 1.472-3.81h-4.846c-.23 0-.346-.112-.346-.338V.518c0-.226.115-.339.346-.339h9.778Z",
    fill: "#7F939D"
  })));
};
export default SvgRightQuote;